import React, { useContext } from "react";
import { Paper, Grid, Typography } from "@material-ui/core";
import MonetizationOnOutlinedIcon from "@material-ui/icons/MonetizationOnOutlined";
import PeopleAltOutlinedIcon from "@material-ui/icons/PeopleAltOutlined";
import ReceiptOutlinedIcon from "@material-ui/icons/ReceiptOutlined";
import LocalOfferOutlinedIcon from "@material-ui/icons/LocalOfferOutlined";
import themeContext from "../../../../contexts/theme/themeContext";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const TopCards = () => {
  const { gradient_primary, gradient_secondary, gradient_third } = useContext(
    themeContext
  );
  const profile = useSelector((state) => state.profile);

  const { t } = useTranslation();
  const cardsData = [
    {
      title: t("common:account"),
      unit: t("common:SR"),
      bg: gradient_primary,
      icon: MonetizationOnOutlinedIcon,
      // permission: "showownsale",
      value: profile.caisse,
    },
    {
      title: t("common:sales"),
      unit: t("common:SR"),
      bg: "bg-orange-gradient",
      icon: LocalOfferOutlinedIcon,
      // permission: "showownsale",
      value: profile.sales,
    },
    {
      title: t("common:customers"),
      unit: "",
      bg: gradient_secondary,
      icon: PeopleAltOutlinedIcon,
      // permission: "showownsale",
      value: profile.customers,
    },
    {
      title: t("common:quotations"),
      unit: "",
      bg: gradient_third,
      icon: ReceiptOutlinedIcon,
      // permission: "showownsale",
      value: profile.pricelist,
    },
  ];

  // const cards = cardsData.filter((c) =>
  //   permissions.some((per) => per === c.permission)
  // );

  return (
    <Grid container spacing={3} className="py-2">
      {cardsData.map((card, i) => (
        <SingleCard
          key={i}
          title={card.title}
          unit={card.unit}
          bg={card.bg}
          Icon={card.icon}
          value={card.value}
        />
      ))}
    </Grid>
  );
};

export default TopCards;

const SingleCard = ({ title, unit, bg, Icon, value }) => {
  return (
    <Grid item md={3} sm={6} xs={6}>
      <Paper elevation={6} className="p">
        <Grid container>
          <Grid item md={10} sm={10} xs={8}>
            <Typography variant="caption" color="textPrimary">
              {title}
            </Typography>
          </Grid>
          <Grid item md={2} sm={2} xs={4}>
            <Paper
              className={`${bg} p`}
              style={{ marginTop: -22, maxWidth: 40 }}
              elevation={6}
              square
            >
              <Typography variant="h3" className="text-light">
                <Icon fontSize="inherit" style={{ marginTop: 5 }} />
              </Typography>
            </Paper>
          </Grid>
          <Grid item xs={12} className="xp">
            <Typography variant="h6" color="textPrimary">
              {value} {unit}
            </Typography>
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  );
};
